import { enseignantsConstants as ensg } from "../../../constants/enseignants";

const initialState = {
  loading: true,
  list: [],
  data: null,
  contrats: [],
  contrat: null,
  avenant: null,
  evaluation: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ensg.GET_ENSEIGNANTS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case ensg.GET_ENSEIGNANT:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case ensg.GET_CONTRATS:
      return {
        ...state,
        loading: false,
        contrats: payload,
      };
    case ensg.GET_CONTRAT:
      return {
        ...state,
        loading: false,
        contrat: payload,
      };
    case ensg.GET_AVENANT:
      return {
        ...state,
        loading: false,
        avenant: payload,
      };
    case ensg.GET_EVALUATION:
      return {
        ...state,
        loading: false,
        evaluation: payload,
      };
    default:
      return state;
  }
}
